import { OrganisationProvider, useOrganisation } from "@RequestFormV2/sections/Organisation/context";
import LocationDetailsSection from "@RequestFormV2/sections/Organisation/components/LocationDetailsSection";
import ShipmentDetailsSection from "@RequestFormV2/sections/Organisation/components/ShipmentDetailsSection";
import AdditionalInformationSection from "@RequestFormV2/sections/Organisation/components/AdditionalInformationSection";

function OrganisationContent() {
  const { selectedLocation } = useOrganisation();

  return (
    <>
      <LocationDetailsSection />
      {selectedLocation && (
        <>
          <ShipmentDetailsSection />
          <AdditionalInformationSection />
        </>
      )}
    </>
  );
}

export default function Organisation() {
  return (
    <OrganisationProvider>
      <OrganisationContent />
    </OrganisationProvider>
  );
}
